import React from "react";
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {exceptionCells} from "./ConstructionTableProps";
import type GuiValueDto from "../../../../dto/construction/GuiValueDto";
import ConstructionTableEditableCell from "./ConstructionTableEditableCell";
import ConstructionTableToggleCell from "./ConstructionTableToggleCell";
import ConstructionTableFixedCell from "./ConstructionTableFixedCell";
import formatCell from "./constructionTabelRowCellHelpers";
import useConstructionTableRowCellHook from "../../hooks/useConstructionTableRowCellHook";

interface ConstructionTableCellProps {
  constructionElementParentId: string;
  constructionElementEntityId: string;
  constructionElementsName: string;
  constructionElementProperty: string;
  header: string;
  guiValue: GuiValueDto<string | number | boolean>;
  constructionId: string;
  isAccepted: boolean;
  renderEmpty?: boolean;
  extraInfo?: { family: string };
}

const displayIsaacToggleButton = (constructionElementsName: string, constructionElementProperty: string): boolean => {
  if (
    constructionElementProperty === "isSelected" &&
    (constructionElementsName === "beams" ||
      constructionElementsName === "supportArms" ||
      constructionElementsName === "catenaries" ||
      constructionElementsName === "wires" ||
      constructionElementsName === "crossSpanWires" ||
      constructionElementsName === "hingedCantilevers" ||
      constructionElementsName === "devices")
  ) {
    return true;
  } else {
    return false;
  }
};

const ConstructionTableRowCell: React.FunctionComponent<ConstructionTableCellProps> = ({
  constructionElementParentId,
  constructionElementEntityId,
  constructionElementsName,
  constructionElementProperty,
  header,
  guiValue,
  constructionId,
  isAccepted,
  renderEmpty,
  extraInfo,
}) => {
  const {acceptedMast, isChecked} = useConstructionTableRowCellHook({
    constructionElementParentId,
    constructionElementEntityId,
    constructionElementsName,
    constructionElementProperty,
    header,
    guiValue,
    formatCell,
    displayIsaacToggleButton,
  });

  if (acceptedMast) {
    return <>{acceptedMast}</>;
  }

  const isRowEnabled = isChecked() && !isAccepted;

  if (displayIsaacToggleButton(constructionElementsName, constructionElementProperty)) {
    return (
      <td style={{color: isRowEnabled ? "#000" : "#ccc"}}>
        <ConstructionTableToggleCell
          constructionElementParentId={constructionElementParentId}
          constructionElementEntityId={constructionElementEntityId}
          isChecked={isChecked}
          disabled={isAccepted}
        />
      </td>
    );
  }

  if (exceptionCells.includes(header)) {
    return null;
  }

  if (!guiValue.isEditable) {
    return (
      <td style={{color: isRowEnabled ? "#000" : "#ccc"}}>
        <ConstructionTableFixedCell value={formatCell(guiValue.value)} />
      </td>
    );
  }

  if (isRowEnabled) {
    if (!renderEmpty) {
      return (
        <td style={{color: "#000"}}>
          <ConstructionTableEditableCell
            constructionId={constructionId}
            constructionElementsName={constructionElementsName}
            constructionElementProperty={constructionElementProperty}
            constructionElementEntityId={constructionElementEntityId}
            type={guiValue.editableType}
            value={guiValue.value}
            extraInfo={extraInfo}
          />
        </td>
      );
    } else {
      return (
        <td style={{color: "#ccc"}}>
          <ConstructionTableFixedCell value={formatCell(guiValue.value)} />
        </td>
      );
    }
  }

  return (
    <td style={{color: "#ccc"}}>
      <ConstructionTableFixedCell value={formatCell(guiValue.value)} />
    </td>
  );
};

export default ConstructionTableRowCell;
